<template>
    <v-footer app padless>
        <v-col class="text-center pa-0" cols="12">
            <v-divider></v-divider>
            <p class="footer-text">© 2024 Question Managing System - Version {{ appVersion }}</p>
        </v-col>
    </v-footer>
</template>

<script>
export default {
    name: 'AppFooter',
    setup() {
        const appVersion = '2.3.0'
        return { appVersion }
    }
}
</script>

<style>
.footer-text {
    font-size: 0.7rem;
}
</style>
